import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './sites/landingPage/LandingPage';
import BetaSignupPage from './sites/betaSignup/BetaSignup';
import Impressum from './sites/impressum/impressum';
import Datenschutz from './sites/datenschutz/datenschutz';
import { SupportPage } from './sites/support/SupportPage';
import { EmailConfirmation } from './sites/emailConfirmation/EmailConfirmation';
import { AppDatenschutz } from './sites/appDatenschutz/AppDatenschutz';
import { AgbsPage } from './sites/agbs/Agbs';
import { ConceptPage } from './sites/concept/Concept';
import LinkRedirect from './sites/linkRedirect/LinkRedirect';
import DeviceLinkRedirect from './sites/deviceLinkRedirect/DeviceLinkRedirect';
import GroupInviteRedirect from './sites/groupInviteRedirect/GroupInviteRedirect';
import BlogPage from './sites/blog/Blog';
import BlogDetailPage from './sites/blog/BlogDetail';

const ResetPasswordPage = lazy(() =>
	import('./sites/resetPassword/ResetPassword').then((m) => ({ default: m.ResetPasswordPage }))
);

function App() {
	return (
		<Routes>
			<Route path='/link-redirect' element={<LinkRedirect />} />
			<Route path='/' element={<LandingPage />} />
			<Route path='/beta-signup' element={<BetaSignupPage />} />
			<Route path='/concept' element={<ConceptPage />} />
			<Route path='/support' element={<SupportPage />} />
			<Route path='/auth/confirm' element={<EmailConfirmation />} />
			<Route
				path='/reset-password'
				element={
					<Suspense fallback={null}>
						<ResetPasswordPage />
					</Suspense>
				}
			/>
			<Route path='/impressum' element={<Impressum />} />
			<Route path='/datenschutz' element={<Datenschutz />} />
			<Route path='/app-datenschutz' element={<AppDatenschutz />} />
			<Route path='/agbs' element={<AgbsPage />} />
			<Route path='/device-link-redirect' element={<DeviceLinkRedirect />} />
			<Route path='/group-invite-redirect' element={<GroupInviteRedirect />} />
			<Route path='/blog' element={<BlogPage />} />
			<Route path='/blog/:id' element={<BlogDetailPage />} />
		</Routes>
	);
}

export default App;
